module.exports = __webpack_public_path__ + "static/media/599.705493(8).e4d4d72d.pdf";